// Deterministic avatar color + heat colors for real staff records. The
// server carries no design palette, so the color derives from the record's
// id and stays stable across renders. Initials come from api/auth's
// initialsOf - the same helper the account menu uses, so a person's own
// avatar never disagrees with their team row.

const STAFF_COLORS = [
  "#1e3c72",
  "#c2410c",
  "#0e7490",
  "#be185d",
  "#b45309",
  "#047857",
  "#475569",
  "#dc2626",
];

export function colorFor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return STAFF_COLORS[hash % STAFF_COLORS.length];
}

export function heatColor(heat: "balanced" | "heavy" | "overloaded"): string {
  if (heat === "overloaded") return "var(--red-700)";
  if (heat === "heavy") return "var(--warn-600)";
  return "var(--ok-600)";
}
